/*
* Copyright (c) 2009-2022. Authors: see NOTICE file.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*      http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

import {Cytomine, User} from 'cytomine-client';

function getDefaultState() {
  return {
    user: null,
    expandedSidebar: false,
    increment: 0,
    shortTermToken: null
  };
}

export default {
  namespaced: true,

  state: getDefaultState(),

  mutations: {
    setUser(state, user) {
      state.user = user ? user.clone() : null;
    },
    setShortTermToken(state, value) {
      state.shortTermToken = value;
    },
    setSuperAdminByNow(state, value) {
      if(state.user) {
        state.user.superAdminByNow = value;
      }
    },
    setAdminByNow(state, value) {
      if(state.user) {
        state.user.adminByNow = value;
      }
    },
    setExpandedSidebar(state, val) {
      state.expandedSidebar = val;
    },
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
  },

  actions: {
    async fetchUser({commit, dispatch}) {
      let user = await User.fetchCurrent();
      if(user.id) { // fetchCurrent() redirects to home page if user not authenticated => check that id is set
        commit('setUser', user);

        try {
          await dispatch('openAdminSession');
        }
        catch (e) {
          console.log('non-admin user');
        }
      }
      else {
        commit('setUser', null);
      }
    },

    async updateUser({commit}, user) {
      await user.update();
      commit('setUser', user);
    },

    async regenerateKeys({state, commit}) {
      let user = state.user.clone();
      await user.regenerateKeys();
      commit('setUser', user);
    },

    async openAdminSession({commit}) {
      const authInfo = await Cytomine.instance.openAdminSession();
      commit('setAdminByNow', authInfo.adminByNow);
      commit('setSuperAdminByNow', authInfo.superAdminByNow);
    },
    async closeAdminSession({dispatch}) {
      await Cytomine.instance.closeAdminSession();
      await dispatch('fetchUser');
    },

    async login({dispatch, commit}, payload) {
      let {shortTermToken} = await Cytomine.instance.login(payload.username, payload.password, payload.rememberMe);
      commit('setShortTermToken', shortTermToken);
      await dispatch('fetchUser');
    }
  },

  getters: {
    // SuperAdmin 여부를 판별하는 Getter 추가
    isSuperAdmin: state => {
      return state.user ? !!state.user.superAdminByNow : false;
    },
    // Admin 또는 SuperAdmin 중 하나라도 해당되는지 확인
    isAdminOrSuperAdmin: (state, getters) => {
      return (state.user && state.user.adminByNow) || getters.isSuperAdmin;
    },
    currentShortTermToken: (state, _, rootState) => {
      let currentUser = rootState.currentUser || {};
      return currentUser.shortTermToken;
    },
  }

};
